import { rgba } from 'polished';
import styled from 'styled-components';
import { getPublicPath } from 'utils/paths';
import { color, spacing, zindex } from '../../../theme';

export const StyledHero = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: -${spacing('xl4')};
  padding-bottom: ${spacing('xl3')};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: ${zindex('heroBg')};
    background-color: ${color('midnight_900')};
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(
      147deg,
      ${color('purple_900')} 0%,
      ${rgba('#1e076e', 0.6)} 70%,
      transparent 100%
    );
    mix-blend-mode: hard-light;
    z-index: ${zindex('heroBgGradient')};
  }
`;

export const StyledHeroBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.2;
  z-index: ${zindex('heroSectionBg')};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${color('emerald_500')};
    mix-blend-mode: darken;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: black;
    mix-blend-mode: lighten;
  }

  div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('${getPublicPath('/images/launch/hero-bg.jpg')}');
    background-size: cover;
    background-position: center center;
    filter: grayscale(100%);
    z-index: ${zindex('heroSectionBgImg')};
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  z-index: ${zindex('heroContent')};
  text-align: center;
  color: ${color('text_white')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: ${spacing('xl4')};
`;

export const StyledHeadingCarousel = styled.span`
  display: block;
  font-size: 175%;
  margin-top: ${spacing('md')};
  margin-bottom: ${spacing('md')};
  height: 1.35em;
  overflow: hidden;
`;

export const StyledHeadingCarouselInner = styled.span`
  display: block;
  animation: wordSlider ease-out infinite 12s;

  > span {
    display: block;
    line-height: 1.3em;
    color: ${color('emerald_300')};

    &:nth-child(2) {
      color: ${color('sun_500')};
    }

    &:nth-child(3) {
      color: ${color('negative_200')};
    }

    &:nth-child(4) {
      color: ${color('indigo_300')};
    }

    &:nth-child(5) {
      color: ${color('purple_100')};
    }
  }

  @keyframes wordSlider {
    0%,
    16% {
      transform: translateY(0%);
    }
    20%,
    36% {
      transform: translateY(-16.66%);
    }
    40%,
    56% {
      transform: translateY(-33.33%);
    }
    60%,
    76% {
      transform: translateY(-50%);
    }
    80%,
    96% {
      transform: translateY(-66.66%);
    }
    100% {
      transform: translateY(-83.33%);
    }
  }
`;
